import { createAction } from "@reduxjs/toolkit";
import {
  ADD_TICKET_WITH_EXERCISE_TO_BAKSKET, ADD_TICKET_WITH_SEAT_TO_BASKET, CLEAR_BASKET,
  CLEAR_SELECT_EXERCISE,
  REMOVE_TICKET_WITH_EXERCISE_FROM_BASKET, REMOVE_TICKET_WITH_SEAT_FROM_BASKET,
  SELECT_EXERCISE, SELECT_EXERCISE_BY_SEAT, SET_ACTIVE_STEP,
} from "./basketTypes";
import { Exercise } from "../../models/Exercise";
import { TicketBillLine } from "../../models/TicketBillLine";

export const selectExercise = createAction<Exercise>(SELECT_EXERCISE);
export const clearSelectExercise = createAction<void>(CLEAR_SELECT_EXERCISE);
export const addTicketWithExerciseToBasket = createAction<TicketBillLine>(ADD_TICKET_WITH_EXERCISE_TO_BAKSKET);
export const removeTicketWithExerciseFromBasket = createAction<TicketBillLine>(REMOVE_TICKET_WITH_EXERCISE_FROM_BASKET);
export const clearBasket = createAction<void>(CLEAR_BASKET);
export const selectExerciseBySeat = createAction<Exercise>(SELECT_EXERCISE_BY_SEAT);
export const addTicketWithSeatToBasket = createAction<TicketBillLine>(ADD_TICKET_WITH_SEAT_TO_BASKET);
export const removeTicketWithSeatFromBasket = createAction<TicketBillLine>(REMOVE_TICKET_WITH_SEAT_FROM_BASKET);
export const setActiveStep = createAction<number>(SET_ACTIVE_STEP);
